import { Job } from './Job'
import {
  getSeaExportJobByUuid,
  loadSeaExportJobRelated,
  queryEDIFeedBackState,
  batchCloneLcLJob,
  checkJobFiledExist,
  isExistMBL,
  isExistSIMBL,
  isExistHBL,
  generateHblNo,
  checkMBLNoRepeat,
  isExistCustomerRefNo,
  isExistSoNo,
  isExistMBLNotCurrentCompany, isExistMBLSeaExport, isExistScNo
} from '@/api/seaExport/seaExportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import $store from '@/store'
import { sortByMultiFieldAndOrder } from '@/utils'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'

export class SeaExportJob extends Job {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'SeaExportJob'
  }

  get containerLoadType() {
    return this._data.containerLoadType
  }
  set containerLoadType(containerLoadType) {
    this._data.containerLoadType = containerLoadType
  }
  get selfConsolidation() {
    return this._data.selfConsolidation
  }
  set selfConsolidation(selfConsolidation) {
    this._data.selfConsolidation = selfConsolidation || false
  }
  get loadingTerm() {
    return this._data.loadingTerm
  }
  set loadingTerm(loadingTerm) {
    this._data.loadingTerm = loadingTerm
  }
  get bookingTerm() {
    return this._data.bookingTerm
  }
  set bookingTerm(bookingTerm) {
    this._data.bookingTerm = bookingTerm
  }
  get customClaim() {
    return this._data.customClaim
  }
  set customClaim(customClaim) {
    this._data.customClaim = customClaim || -1
  }
  get incoTerm() {
    return this._data.incoTerm
  }
  set incoTerm(incoTerm) {
    this._data.incoTerm = incoTerm
  }
  get dangerousGoods() {
    return this._data.dangerousGoods
  }
  set dangerousGoods(dangerousGoods) {
    this._data.dangerousGoods = dangerousGoods || false
  }
  get sailingDay() {
    return this._data.sailingDay
  }
  set sailingDay(sailingDay) {
    this._data.sailingDay = sailingDay
  }
  get freightTerm() {
    return this._data.freightTerm
  }
  set freightTerm(freightTerm) {
    this._data.freightTerm = freightTerm
  }
  get freightTermHBL() {
    return this._data.freightTermHBL
  }
  set freightTermHBL(freightTermHBL) {
    this._data.freightTermHBL = freightTermHBL
  }
  get remarksBooking() {
    return this._data.remarksBooking
  }
  set remarksBooking(remarksBooking) {
    this._data.remarksBooking = remarksBooking
  }
  get remarksShipping() {
    return this._data.remarksShipping
  }
  set remarksShipping(remarksShipping) {
    this._data.remarksShipping = remarksShipping
  }
  get insideQuantity() {
    return this._data.insideQuantity
  }
  set insideQuantity(insideQuantity) {
    this._data.insideQuantity = insideQuantity || 0
  }
  get insidePacking() {
    return this._data.insidePacking
  }
  set insidePacking(insidePacking) {
    this._data.insidePacking = insidePacking
  }
  get secondVesselETD() {
    return this._data.secondVesselETD
  }
  set secondVesselETD(secondVesselETD) {
    this._data.secondVesselETD = secondVesselETD
  }
  get secondVesselVoyage() {
    return this._data.secondVesselVoyage
  }
  set secondVesselVoyage(secondVesselVoyage) {
    this._data.secondVesselVoyage = secondVesselVoyage
  }
  get secondVoyage() {
    return this._data.secondVoyage
  }
  set secondVoyage(secondVoyage) {
    this._data.secondVoyage = secondVoyage
  }
  get thirdVesselETD() {
    return this._data.thirdVesselETD
  }
  set thirdVesselETD(thirdVesselETD) {
    this._data.thirdVesselETD = thirdVesselETD
  }
  get thirdVesselVoyage() {
    return this._data.thirdVesselVoyage
  }
  set thirdVesselVoyage(thirdVesselVoyage) {
    this._data.thirdVesselVoyage = thirdVesselVoyage
  }
  get portDistrict() {
    return this._data.portDistrict
  }
  set portDistrict(portDistrict) {
    this._data.portDistrict = portDistrict
  }
  get portCode() {
    return this._data.portCode
  }
  set portCode(portCode) {
    this._data.portCode = portCode
  }
  get addressEIR() {
    return this._data.addressEIR
  }
  set addressEIR(addressEIR) {
    this._data.addressEIR = addressEIR
  }
  get contactEIR() {
    return this._data.contactEIR
  }
  set contactEIR(contactEIR) {
    this._data.contactEIR = contactEIR
  }
  get phoneEIR() {
    return this._data.phoneEIR
  }
  set phoneEIR(phoneEIR) {
    this._data.phoneEIR = phoneEIR
  }
  get terminalOpendate() {
    return this._data.terminalOpendate
  }
  set terminalOpendate(terminalOpendate) {
    this._data.terminalOpendate = terminalOpendate
  }
  get terminalCutoff() {
    return this._data.terminalCutoff
  }
  set terminalCutoff(terminalCutoff) {
    this._data.terminalCutoff = terminalCutoff
  }
  get customCutoff() {
    return this._data.customCutoff
  }
  set customCutoff(customCutoff) {
    this._data.customCutoff = customCutoff
  }
  get fileCutoff() {
    return this._data.fileCutoff
  }
  set fileCutoff(fileCutoff) {
    this._data.fileCutoff = fileCutoff
  }
  get declareCutOff() {
    return this._data.declareCutOff
  }
  set declareCutOff(declareCutOff) {
    this._data.declareCutOff = declareCutOff
  }
  get comercialInspectation() {
    return this._data.comercialInspectation
  }
  set comercialInspectation(comercialInspectation) {
    this._data.comercialInspectation = comercialInspectation || false
  }
  get transfering() {
    return this._data.transfering
  }
  set transfering(transfering) {
    this._data.transfering = transfering || false
  }
  get customs() {
    return this._data.customs
  }
  set customs(customs) {
    this._data.customs = customs || false
  }

  get availableCabinSpace() {
    return this._data.availableCabinSpace
  }
  set availableCabinSpace(availableCabinSpace) {
    this._data.availableCabinSpace = availableCabinSpace || false
  }
  get cabinManagementUuid() {
    return this._data.cabinManagementUuid
  }
  set cabinManagementUuid(cabinManagementUuid) {
    this._data.cabinManagementUuid = cabinManagementUuid
  }
  get heating() {
    return this._data.heating
  }
  set heating(heating) {
    this._data.heating = heating || false
  }
  get batch() {
    return this._data.batch
  }
  set batch(batch) {
    this._data.batch = batch || false
  }
  get ams() {
    return this._data.ams
  }
  set ams(ams) {
    this._data.ams = ams || false
  }
  get barge() {
    return this._data.barge
  }
  set barge(barge) {
    this._data.barge = barge || false
  }
  get vgm() {
    return this._data.vgm
  }
  set vgm(vgm) {
    this._data.vgm = vgm || false
  }
  get bargeVessel() {
    return this._data.bargeVessel
  }
  set bargeVessel(bargeVessel) {
    this._data.bargeVessel = bargeVessel
  }
  get bargeVoyage() {
    return this._data.bargeVoyage
  }
  set bargeVoyage(bargeVoyage) {
    this._data.bargeVoyage = bargeVoyage
  }
  get bargeETD() {
    return this._data.bargeETD
  }
  set bargeETD(bargeETD) {
    this._data.bargeETD = bargeETD
  }
  get bargeETA() {
    return this._data.bargeETA
  }
  set bargeETA(bargeETA) {
    this._data.bargeETA = bargeETA
  }
  get bargePOL() {
    return this._data.bargePOL
  }
  set bargePOL(bargePOL) {
    this._data.bargePOL = bargePOL
  }
  get bargePOD() {
    return this._data.bargePOD
  }
  set bargePOD(bargePOD) {
    this._data.bargePOD = bargePOD
  }
  get soNo() {
    return this._data.soNo
  }
  set soNo(soNo) {
    this._data.soNo = soNo
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount || 0
  }
  get quotationNo() {
    return this._data.quotationNo
  }
  set quotationNo(quotationNo) {
    this._data.quotationNo = quotationNo
  }
  get bookingEDI() {
    return this._data.bookingEDI
  }
  set bookingEDI(bookingEDI) {
    this._data.bookingEDI = bookingEDI || false
  }
  get blEDI() {
    return this._data.blEDI
  }
  set blEDI(blEDI) {
    this._data.blEDI = blEDI || false
  }
  get agentEDI() {
    return this._data.agentEDI
  }
  set agentEDI(agentEDI) {
    this._data.agentEDI = agentEDI || false
  }
  get soc() {
    return this._data.soc
  }
  set soc(soc) {
    this._data.soc = soc || false
  }
  get socType() {
    return this._data.socType
  }
  set socType(socType) {
    this._data.socType = socType
  }
  get agentPrice() {
    return this._data.agentPrice
  }
  set agentPrice(agentPrice) {
    this._data.agentPrice = agentPrice || false
  }
  get transferPortCode() {
    return this._data.transferPortCode
  }
  set transferPortCode(transferPortCode) {
    this._data.transferPortCode = transferPortCode
  }
  get warehousePrinted() {
    return this._data.warehousePrinted
  }
  set warehousePrinted(warehousePrinted) {
    this._data.warehousePrinted = warehousePrinted || false
  }
  get priceOwner() {
    return this._data.priceOwner
  }
  set priceOwner(priceOwner) {
    this._data.priceOwner = priceOwner || 0
  }
  get yardCode() {
    return this._data.yardCode
  }
  set yardCode(yardCode) {
    this._data.yardCode = yardCode
  }
  get vesselCode() {
    return this._data.vesselCode
  }
  set vesselCode(vesselCode) {
    this._data.vesselCode = vesselCode
  }
  get carrierCode() {
    return this._data.carrierCode
  }
  set carrierCode(carrierCode) {
    this._data.carrierCode = carrierCode
  }
  get apCode() {
    return this._data.apCode
  }
  set apCode(apCode) {
    this._data.apCode = apCode
  }
  get apName() {
    return this._data.apName
  }
  set apName(apName) {
    this._data.apName = apName
  }
  get bookingNo() {
    return this._data.bookingNo
  }
  set bookingNo(bookingNo) {
    this._data.bookingNo = bookingNo
  }
  get hds() {
    return this._data.hds
  }
  set hds(hds) {
    this._data.hds = hds || false
  }
  get scNo() {
    return this._data.scNo
  }
  set scNo(scNo) {
    this._data.scNo = scNo
  }
  get customerCutoff() {
    return this._data.customerCutoff
  }
  set customerCutoff(customerCutoff) {
    this._data.customerCutoff = customerCutoff
  }
  get customerShutout() {
    return this._data.customerShutout
  }
  set customerShutout(customerShutout) {
    this._data.customerShutout = customerShutout
  }
  get customerFileCutoff() {
    return this._data.customerFileCutoff
  }
  set customerFileCutoff(customerFileCutoff) {
    this._data.customerFileCutoff = customerFileCutoff
  }
  get bargeCustomCutoff() {
    return this._data.bargeCustomCutoff
  }
  set bargeCustomCutoff(bargeCustomCutoff) {
    this._data.bargeCustomCutoff = bargeCustomCutoff
  }
  get vesselLineCode() {
    return this._data.vesselLineCode
  }
  set vesselLineCode(vesselLineCode) {
    this._data.vesselLineCode = vesselLineCode
  }
  get freeTime() {
    return this._data.freeTime
  }
  set freeTime(freeTime) {
    this._data.freeTime = freeTime || 0
  }
  get returnPeriodBegin() {
    return this._data.returnPeriodBegin
  }
  set returnPeriodBegin(returnPeriodBegin) {
    this._data.returnPeriodBegin = returnPeriodBegin
  }
  get returnPeriodEnd() {
    return this._data.returnPeriodEnd
  }
  set returnPeriodEnd(returnPeriodEnd) {
    this._data.returnPeriodEnd = returnPeriodEnd
  }
  get amsCutoff() {
    return this._data.amsCutoff
  }
  set amsCutoff(amsCutoff) {
    this._data.amsCutoff = amsCutoff
  }
  get operationTips() {
    return this._data.operationTips
  }
  set operationTips(operationTips) {
    this._data.operationTips = operationTips
  }
  get laneCode() {
    return this._data.laneCode
  }
  set laneCode(laneCode) {
    this._data.laneCode = laneCode
  }
  get subContractNo() {
    return this._data.subContractNo
  }
  set subContractNo(subContractNo) {
    this._data.subContractNo = subContractNo
  }
  get na() {
    return this._data.na
  }
  set na(na) {
    this._data.na = na
  }
  get naCode() {
    return this._data.naCode
  }
  set naCode(naCode) {
    this._data.naCode = naCode
  }
  get realArrivalsDate() {
    return this._data.realArrivalsDate
  }
  set realArrivalsDate(realArrivalsDate) {
    this._data.realArrivalsDate = realArrivalsDate
  }
  get berthPlanDate() {
    return this._data.berthPlanDate
  }
  set berthPlanDate(berthPlanDate) {
    this._data.berthPlanDate = berthPlanDate
  }
  get unBerthPlanDate() {
    return this._data.unBerthPlanDate
  }
  set unBerthPlanDate(unBerthPlanDate) {
    this._data.unBerthPlanDate = unBerthPlanDate
  }
  get actualBerthPlanDate() {
    return this._data.actualBerthPlanDate
  }
  set actualBerthPlanDate(actualBerthPlanDate) {
    this._data.actualBerthPlanDate = actualBerthPlanDate
  }
  get actualUnBerthPlanDate() {
    return this._data.actualUnBerthPlanDate
  }
  set actualUnBerthPlanDate(actualUnBerthPlanDate) {
    this._data.actualUnBerthPlanDate = actualUnBerthPlanDate
  }
  get berthPlanPlace() {
    return this._data.berthPlanPlace
  }
  set berthPlanPlace(berthPlanPlace) {
    this._data.berthPlanPlace = berthPlanPlace
  }
  get actualBerthPlanPlace() {
    return this._data.actualBerthPlanPlace
  }
  set actualBerthPlanPlace(actualBerthPlanPlace) {
    this._data.actualBerthPlanPlace = actualBerthPlanPlace
  }
  get fnlTm() {
    return this._data.fnlTm
  }
  set fnlTm(fnlTm) {
    this._data.fnlTm = fnlTm
  }
  get insideQuantitySize() {
    return this._data.insideQuantitySize
  }
  set insideQuantitySize(insideQuantitySize) {
    this._data.insideQuantitySize = insideQuantitySize || 0
  }
  get spelling() {
    return this._data.spelling
  }
  set spelling(spelling) {
    this._data.spelling = spelling || false
  }
  get vesselIMO() {
    return this._data.vesselIMO
  }
  set vesselIMO(vesselIMO) {
    this._data.vesselIMO = vesselIMO
  }
  get estimatedArrivalTime() {
    return this._data.estimatedArrivalTime
  }
  set estimatedArrivalTime(estimatedArrivalTime) {
    this._data.estimatedArrivalTime = estimatedArrivalTime
  }
  get actualArrivalTime() {
    return this._data.actualArrivalTime
  }
  set actualArrivalTime(actualArrivalTime) {
    this._data.actualArrivalTime = actualArrivalTime
  }
  get currentArrivalTime() {
    return this._data.currentArrivalTime
  }
  set currentArrivalTime(currentArrivalTime) {
    this._data.currentArrivalTime = currentArrivalTime
  }
  get destPortCustomsClearanceTime() {
    return this._data.destPortCustomsClearanceTime
  }
  set destPortCustomsClearanceTime(destPortCustomsClearanceTime) {
    this._data.destPortCustomsClearanceTime = destPortCustomsClearanceTime
  }
  get destPortDeliveryTime() {
    return this._data.destPortDeliveryTime
  }
  set destPortDeliveryTime(destPortDeliveryTime) {
    this._data.destPortDeliveryTime = destPortDeliveryTime
  }
  get destPortReturnTime() {
    return this._data.destPortReturnTime
  }
  set destPortReturnTime(destPortReturnTime) {
    this._data.destPortReturnTime = destPortReturnTime
  }
  get deliveryTime() {
    return this._data.deliveryTime
  }
  set deliveryTime(deliveryTime) {
    this._data.deliveryTime = deliveryTime
  }
  get subTenantId() {
    return this._data.subTenantId
  }
  set subTenantId(subTenantId) {
    this._data.subTenantId = subTenantId || 0
  }
  get validSeaPort() {
    return this._data.validSeaPort
  }
  set validSeaPort(validSeaPort) {
    this._data.validSeaPort = validSeaPort
  }
  get estimatedPackDate() {
    return this._data.estimatedPackDate
  }
  set estimatedPackDate(estimatedPackDate) {
    this._data.estimatedPackDate = estimatedPackDate
  }
  get arrivalTime() {
    return this._data.arrivalTime
  }
  set arrivalTime(arrivalTime) {
    this._data.arrivalTime = arrivalTime
  }
  get deliveryCompletionDate() {
    return this._data.deliveryCompletionDate
  }
  set deliveryCompletionDate(deliveryCompletionDate) {
    this._data.deliveryCompletionDate = deliveryCompletionDate
  }
  get secondPol() {
    return this._data.secondPol
  }
  set secondPol(secondPol) {
    this._data.secondPol = secondPol
  }
  get secondPod() {
    return this._data.secondPod
  }
  set secondPod(secondPod) {
    this._data.secondPod = secondPod
  }
  get secondPolCode() {
    return this._data.secondPolCode
  }
  set secondPolCode(secondPolCode) {
    this._data.secondPolCode = secondPolCode
  }
  get secondPodCode() {
    return this._data.secondPodCode
  }
  set secondPodCode(secondPodCode) {
    this._data.secondPodCode = secondPodCode
  }
  get secondArrivalsDate() {
    return this._data.secondArrivalsDate
  }
  set secondArrivalsDate(secondArrivalsDate) {
    this._data.secondArrivalsDate = secondArrivalsDate
  }
  get secondUnloadingDate() {
    return this._data.secondUnloadingDate
  }
  set secondUnloadingDate(secondUnloadingDate) {
    this._data.secondUnloadingDate = secondUnloadingDate
  }
  get secondLoadingDate() {
    return this._data.secondLoadingDate
  }
  set secondLoadingDate(secondLoadingDate) {
    this._data.secondLoadingDate = secondLoadingDate
  }
  get secondShipmentDate() {
    return this._data.secondShipmentDate
  }
  set secondShipmentDate(secondShipmentDate) {
    this._data.secondShipmentDate = secondShipmentDate
  }
  /* 关联实体-begin */
  get cargoDoc() {
    return this._data.cargoDoc
  }
  set cargoDoc(cargoDoc) {
    this._data.cargoDoc = this._data.seaCargoDoc = cargoDoc
  }
  get seaCargoDoc() {
    return this._data.seaCargoDoc
  }
  set seaCargoDoc(seaCargoDoc) {
    this._data.seaCargoDoc = this._data.cargoDoc = seaCargoDoc
  }
  get mscCargoDoc() {
    return this._data.mscCargoDoc
  }
  set mscCargoDoc(mscCargoDoc) {
    this._data.mscCargoDoc = mscCargoDoc
  }
  get vgms() {
    return this._data.vgms
  }
  set vgms(vgms) {
    this._data.vgms = vgms
  }
  get chargeWeightContract() {
    return this._data.chargeWeightContract
  }
  set chargeWeightContract(chargeWeightContract) {
    this._data.chargeWeightContract = chargeWeightContract || 0
  }
  get volumetricWeightContract() {
    return this._data.volumetricWeightContract
  }
  set volumetricWeightContract(volumetricWeightContract) {
    this._data.volumetricWeightContract = volumetricWeightContract || 0
  }
  get cargoBulkDetail() {
    return this._data.cargoBulkDetail
  }
  set cargoBulkDetail(cargoBulkDetail) {
    this._data.cargoBulkDetail = cargoBulkDetail
  }
  // 下载模版相关代码撤回
  get freeDemurrage() {
    return this._data.freeDemurrage
  }
  set freeDemurrage(freeDemurrage) {
    this._data.freeDemurrage = freeDemurrage
  }
  get freeDetention() {
    return this._data.freeDetention
  }
  set freeDetention(freeDetention) {
    this._data.freeDetention = freeDetention
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get customsAreaApplication() {
    return this._data.customsAreaApplication
  }
  set customsAreaApplication(customsAreaApplication) {
    this._data.customsAreaApplication = customsAreaApplication
  }
  get surchargeTerms() {
    return this._data.surchargeTerms
  }
  set surchargeTerms(surchargeTerms) {
    this._data.surchargeTerms = surchargeTerms
  }
  get blForm() {
    return this._data.blForm
  }
  set blForm(blForm) {
    this._data.blForm = blForm
  }
  // 内部约号
  get contractNo() {
    return this._data.contractNo
  }
  set contractNo(contractNo) {
    this._data.contractNo = contractNo
  }
  // 渠道单号
  get channelNo() {
    return this._data.channelNo
  }
  set channelNo(channelNo) {
    this._data.channelNo = channelNo
  }
  // 报价单号
  get quotationNum() {
    return this._data.quotationNum
  }
  set quotationNum(quotationNum) {
    this._data.quotationNum = quotationNum
  }
  get mblConfigName() {
    return this._data.mblConfigName
  }
  set mblConfigName(mblConfigName) {
    this._data.mblConfigName = mblConfigName
  }

  // 船公司截港时间
  get carrierCyCutOffTime() {
    return this._data.carrierCyCutOffTime
  }
  set carrierCyCutOffTime(carrierCyCutOffTime) {
    this._data.carrierCyCutOffTime = carrierCyCutOffTime
  }

  // 卸船时间
  get portDischargeTime() {
    return this._data.portDischargeTime
  }
  set portDischargeTime(portDischargeTime) {
    this._data.portDischargeTime = portDischargeTime
  }

  // 铁路运输时间
  get railwayDepartureTime() {
    return this._data.railwayDepartureTime
  }
  set railwayDepartureTime(railwayDepartureTime) {
    this._data.railwayDepartureTime = railwayDepartureTime
  }

  // 铁路卸货时间
  get railwayDischargeTime() {
    return this._data.railwayDischargeTime
  }
  set railwayDischargeTime(railwayDischargeTime) {
    this._data.railwayDischargeTime = railwayDischargeTime
  }

  // 预计放关时间
  get estimatedCustomsReleaseTime() {
    return this._data.estimatedCustomsReleaseTime
  }
  set estimatedCustomsReleaseTime(estimatedCustomsReleaseTime) {
    this._data.estimatedCustomsReleaseTime = estimatedCustomsReleaseTime
  }

  // 目的港查验
  get destPortInspection() {
    return this._data.destPortInspection
  }
  set destPortInspection(destPortInspection) {
    this._data.destPortInspection = destPortInspection || false
  }

  // 目的港查验等级
  get destPortInspectionLevel() {
    return this._data.destPortInspectionLevel
  }
  set destPortInspectionLevel(destPortInspectionLevel) {
    this._data.destPortInspectionLevel = destPortInspectionLevel
  }

  // 预计提重时间
  get estimatedPickUpTime() {
    return this._data.estimatedPickUpTime
  }
  set estimatedPickUpTime(estimatedPickUpTime) {
    this._data.estimatedPickUpTime = estimatedPickUpTime
  }

  // 实际提重时间
  get actualPickUpTime() {
    return this._data.actualPickUpTime
  }
  set actualPickUpTime(actualPickUpTime) {
    this._data.actualPickUpTime = actualPickUpTime
  }

  // 预计还空时间
  get estimatedDeliveryToWarehouseTime() {
    return this._data.estimatedDeliveryToWarehouseTime
  }
  set estimatedDeliveryToWarehouseTime(estimatedDeliveryToWarehouseTime) {
    this._data.estimatedDeliveryToWarehouseTime = estimatedDeliveryToWarehouseTime
  }
  // 预计进仓交货时间
  get estimatedReturnTime() {
    return this._data.estimatedReturnTime
  }
  set estimatedReturnTime(estimatedReturnTime) {
    this._data.estimatedReturnTime = estimatedReturnTime
  }
  // 驳船信息备注
  get bargeRemarks() {
    return this._data.bargeRemarks
  }
  set bargeRemarks(bargeRemarks) {
    this._data.bargeRemarks = bargeRemarks
  }
  // 已锁定发货人
  get shipperLock() {
    return this._data.shipperLock
  }
  set shipperLock(shipperLock) {
    this._data.shipperLock = shipperLock || false
  }

  // 预计卸船时间
  get estimatedPortDischargeTime() {
    return this._data.estimatedPortDischargeTime
  }
  set estimatedPortDischargeTime(estimatedPortDischargeTime) {
    this._data.estimatedPortDischargeTime = estimatedPortDischargeTime
  }
  // 预计铁路运输时间
  get estimatedRailwayDepartureTime() {
    return this._data.estimatedRailwayDepartureTime
  }
  set estimatedRailwayDepartureTime(estimatedRailwayDepartureTime) {
    this._data.estimatedRailwayDepartureTime = estimatedRailwayDepartureTime
  }
  // 预计铁路卸货时间
  get estimatedRailwayDischargeTime() {
    return this._data.estimatedRailwayDischargeTime
  }
  set estimatedRailwayDischargeTime(estimatedRailwayDischargeTime) {
    this._data.estimatedRailwayDischargeTime = estimatedRailwayDischargeTime
  }
  // 预计抵达交货地时间
  get estimatedArrivalPlaceOfDelivery() {
    return this._data.estimatedArrivalPlaceOfDelivery
  }
  set estimatedArrivalPlaceOfDelivery(estimatedArrivalPlaceOfDelivery) {
    this._data.estimatedArrivalPlaceOfDelivery = estimatedArrivalPlaceOfDelivery
  }
  // 实际抵达交货地时间
  get actualArrivalPlaceOfDelivery() {
    return this._data.actualArrivalPlaceOfDelivery
  }
  set actualArrivalPlaceOfDelivery(actualArrivalPlaceOfDelivery) {
    this._data.actualArrivalPlaceOfDelivery = actualArrivalPlaceOfDelivery
  }
  // 当前计划靠泊时间
  get currentETA() {
    return this._data.currentETA
  }
  set currentETA(currentETA) {
    this._data.currentETA = currentETA
  }

  // 当前计划离泊时间
  get currentETD() {
    return this._data.currentETD
  }
  set currentETD(currentETD) {
    this._data.currentETD = currentETD
  }
  // VGM通道，1--海管家、0--其他通道
  get vgmChannel() {
    return this._data.vgmChannel
  }
  set vgmChannel(vgmChannel) {
    this._data.vgmChannel = vgmChannel
  }
  // 码头公司
  get terminalCompany() {
    return this._data.terminalCompany
  }
  set terminalCompany(terminalCompany) {
    this._data.terminalCompany = terminalCompany
  }
  // 航线代码
  get routeCode() {
    return this._data.routeCode
  }
  set routeCode(routeCode) {
    this._data.routeCode = routeCode
  }
  get cNptNo() {
    return this._data.cNptNo
  }
  set cNptNo(cNptNo) {
    this._data.cNptNo = cNptNo
  }
  get cNptName() {
    return this._data.cNptName
  }
  set cNptName(cNptName) {
    this._data.cNptName = cNptName
  }
  get seaRailwayTransportation() {
    return this._data.seaRailwayTransportation
  }
  set seaRailwayTransportation(seaRailwayTransportation) {
    this._data.seaRailwayTransportation = seaRailwayTransportation
  }
  get boxOneWay() {
    return this._data.boxOneWay
  }
  set boxOneWay(boxOneWay) {
    this._data.boxOneWay = boxOneWay
  }
  get allocation() {
    return this._data.allocation
  }
  set allocation(allocation) {
    this._data.allocation = allocation
  }

  get electric() {
    return this._data.electric
  }
  set electric(electric) {
    this._data.electric = electric
  }
  get magnetic() {
    return this._data.magnetic
  }
  set magnetic(magnetic) {
    this._data.magnetic = magnetic
  }
  get powder() {
    return this._data.powder
  }
  set powder(powder) {
    this._data.powder = powder
  }
  get liquid() {
    return this._data.liquid
  }
  set liquid(liquid) {
    this._data.liquid = liquid
  }

  // 交货地区域
  get placeOfDeliveryRegion() {
    return this._data.placeOfDeliveryRegion
  }
  set placeOfDeliveryRegion(placeOfDeliveryRegion) {
    this._data.placeOfDeliveryRegion = placeOfDeliveryRegion
  }
  // 转运方式
  get transshipmentTransportationModeCode() {
    return this._data.transshipmentTransportationModeCode
  }
  set transshipmentTransportationModeCode(transshipmentTransportationModeCode) {
    this._data.transshipmentTransportationModeCode = transshipmentTransportationModeCode
  }
  // NOVCC
  get novcc() {
    return this._data.novcc
  }
  set novcc(novcc) {
    this._data.novcc = novcc
  }
  // TLI NO
  get tliNo() {
    return this._data.tliNo
  }
  set tliNo(tliNo) {
    this._data.tliNo = tliNo
  }

  get inquiryPriceNo() {
    return this._data.inquiryPriceNo
  }
  set inquiryPriceNo(inquiryPriceNo) {
    this._data.inquiryPriceNo = inquiryPriceNo || ''
  }
  get prePortQuotationNo() {
    return this._data.prePortQuotationNo
  }
  set prePortQuotationNo(prePortQuotationNo) {
    this._data.prePortQuotationNo = prePortQuotationNo || ''
  }
  get lastMileQuotationNo() {
    return this._data.lastMileQuotationNo
  }
  set lastMileQuotationNo(lastMileQuotationNo) {
    this._data.lastMileQuotationNo = lastMileQuotationNo || ''
  }
  get prePortPlanner() {
    return this._data.prePortPlanner
  }
  set prePortPlanner(prePortPlanner) {
    this._data.prePortPlanner = prePortPlanner || 0
  }
  get lastMilePlanner() {
    return this._data.lastMilePlanner
  }
  set lastMilePlanner(lastMilePlanner) {
    this._data.lastMilePlanner = lastMilePlanner || 0
  }
  get prePortApproveStatus() {
    return this._data.prePortApproveStatus
  }
  set prePortApproveStatus(prePortApproveStatus) {
    this._data.prePortApproveStatus = prePortApproveStatus || 0
  }
  get trunkLineApproveStatus() {
    return this._data.trunkLineApproveStatus
  }
  set trunkLineApproveStatus(trunkLineApproveStatus) {
    this._data.trunkLineApproveStatus = trunkLineApproveStatus || 0
  }
  get lastMileApproveStatus() {
    return this._data.lastMileApproveStatus
  }
  set lastMileApproveStatus(lastMileApproveStatus) {
    this._data.lastMileApproveStatus = lastMileApproveStatus || 0
  }
  get prePortPlannerDepartment() {
    return this._data.prePortPlannerDepartment
  }
  set prePortPlannerDepartment(prePortPlannerDepartment) {
    this._data.prePortPlannerDepartment = prePortPlannerDepartment || 0
  }
  get lastMilePlannerDepartment() {
    return this._data.lastMilePlannerDepartment
  }
  set lastMilePlannerDepartment(lastMilePlannerDepartment) {
    this._data.lastMilePlannerDepartment = lastMilePlannerDepartment || 0
  }
  get prePortPlannerOffice() {
    return this._data.prePortPlannerOffice
  }
  set prePortPlannerOffice(prePortPlannerOffice) {
    this._data.prePortPlannerOffice = prePortPlannerOffice || 0
  }
  get lastMilePlannerOffice() {
    return this._data.lastMilePlannerOffice
  }
  set lastMilePlannerOffice(lastMilePlannerOffice) {
    this._data.lastMilePlannerOffice = lastMilePlannerOffice || 0
  }
  get carrierWebsite() {
    return this._data.carrierWebsite
  }
  set carrierWebsite(carrierWebsite) {
    this._data.carrierWebsite = carrierWebsite
  }
  get agentInformation() {
    return this._data.agentInformation
  }
  set agentInformation(agentInformation) {
    this._data.agentInformation = agentInformation
  }
  // 交叉委托 操作方修改的字段
  get relatedChangeField() {
    return this._data.relatedChangeField
  }
  set relatedChangeField(relatedChangeField) {
    this._data.relatedChangeField = relatedChangeField
  }
  // 客户预定航次
  get customerReserveVoyage() {
    return this._data.customerReserveVoyage
  }
  set customerReserveVoyage(customerReserveVoyage) {
    this._data.customerReserveVoyage = customerReserveVoyage
  }
  // 船名航次
  get vesselAndVoyage() {
    return this._data.vesselAndVoyage
  }
  set vesselAndVoyage(vesselAndVoyage) {
    this._data.vesselAndVoyage = vesselAndVoyage
  }
  // 船司特定代码
  get shippingCompanySpecificCode() {
    return this._data.shippingCompanySpecificCode
  }
  set shippingCompanySpecificCode(shippingCompanySpecificCode) {
    this._data.shippingCompanySpecificCode = shippingCompanySpecificCode
  }
  // 锁定状态
  get lockStatus() {
    return this._data.lockStatus
  }
  set lockStatus(lockStatus) {
    this._data.lockStatus = lockStatus
  }

  get inquiryPriceNo() {
    return this._data.inquiryPriceNo
  }
  set inquiryPriceNo(inquiryPriceNo) {
    this._data.inquiryPriceNo = inquiryPriceNo || ''
  }

  get prePortQuotationNo() {
    return this._data.prePortQuotationNo
  }
  set prePortQuotationNo(prePortQuotationNo) {
    this._data.prePortQuotationNo = prePortQuotationNo || ''
  }

  get lastMileQuotationNo() {
    return this._data.lastMileQuotationNo
  }
  set lastMileQuotationNo(lastMileQuotationNo) {
    this._data.lastMileQuotationNo = lastMileQuotationNo || ''
  }

  get prePortPlanner() {
    return this._data.prePortPlanner
  }
  set prePortPlanner(prePortPlanner) {
    this._data.prePortPlanner = prePortPlanner || 0
  }

  get lastMilePlanner() {
    return this._data.lastMilePlanner
  }
  set lastMilePlanner(lastMilePlanner) {
    this._data.lastMilePlanner = lastMilePlanner || 0
  }

  get airLine() {
    return this._data.airLine
  }

  set airLine(airLine) {
    this._data.airLine = airLine
  }

  get scNoType() {
    return this._data.scNoType
  }
  set scNoType(scNoType) {
    this._data.scNoType = scNoType
  }

  get carrierScac() {
    return this._data.carrierScac
  }
  set carrierScac(carrierScac) {
    this._data.carrierScac = carrierScac
  }

  /* 关联实体-end */
  // 检查字段值是否重复
  static async checkJobFieldExist(branchId, lob, jobFields, jobUuid) {
    return await checkJobFiledExist({ branchId, lob, jobFields, jobUuid }).then(res => res.data)
  }
  // 确认Job是否存在 默认查询三个月内
  static async isExistMBL(branchId, lob, mbl, jobUuid, etd) {
    return await isExistMBL({ branchId, lob, mbl, jobUuid, etd }).then(res => res.data)
  }

  // 确认Job是否存在 默认查询6个月内 从分公司的维度
  static async isExistMBLSeaExport(branchId, lob, mbl, jobUuid, etd) {
    return await isExistMBLSeaExport({ branchId, lob, mbl, jobUuid, etd }).then(res => res.data)
  }
  // 提单号的适用分公司（HQ除外）不等于该业务的操作分公司或者提单适用部门（HQ除外）
  static async isExistMBLNotCurrentCompany(branchId, mbl, departmentId) {
    return await isExistMBLNotCurrentCompany({ branchId, mbl, departmentId }).then(res => res.data)
  }
  // 确认海运进口Job是否存在 默认查询三个月内
  static async isExistSIMBL(branchId, lob, mbl, jobUuid, etd) {
    return await isExistSIMBL({ branchId, lob, mbl, jobUuid, etd }).then(res => res.data)
  }
  // 确认Job是否存在 默认查询三个月内
  static async isExistHBL(branchId, lob, hbl, jobUuid, etd) {
    return await isExistHBL({ branchId, lob, hbl, jobUuid, etd }).then(res => res.data)
  }
  // 确认Job是否存在 默认查询三个月内
  static async generateHblNo(data) {
    return await generateHblNo(data).then(res => res.data)
  }
  static async isExistScNo(data) {
    return await isExistScNo(data).then(res => res.data)
  }
  // 确认 业务参考号是否 存在
  static async isExistCustomerRefNo(branchId, lob, customerRefNo, jobUuid) {
    return await isExistCustomerRefNo({ branchId, lob, customerRefNo, jobUuid }).then(res => res.data)
  }
  // 确认Job是否存在 默认查询三个月内
  static async checkMBLNoRepeat(mbl, jobUuid, masterFlag = false, lclMasterUuid = '', containerLoadType = '') {
    return await checkMBLNoRepeat({ mbl, jobUuid, masterFlag, lclMasterUuid, containerLoadType }).then(res => res.data)
  }
  // 确认SO NO是否存在
  static async isExistSoNo(branchId, lob, soNos, jobUuid) {
    return await isExistSoNo({ branchId, lob, soNos, jobUuid }).then(res => res.data)
  }
  // 加载海出Job的关联实体信息
  async loadJobRelated(params) {
    params.jobUuid = params.jobUuid || this._data.uuid
    if (!params.jobUuid) {
      return
    }
    this.syncCargoDoc()
    // 是否需要载入
    let needLoad = false
    // 将已经加载过的属性的标识置为false
    for (const key in params) {
      if (key === 'jobUuid') {
        continue
      }
      if (params[key] && typeof this._data[key] === 'object') {
        params[key] = false
      }
      if (params[key]) {
        needLoad = true
      }
    }
    if (!needLoad) {
      return
    }
    params.masterFlag = this._data.masterFlag
    await loadSeaExportJobRelated(params).then(res => {
      const items = res.data
      if (items.job) {
        for (const key in items.job) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.job[key]
        }
      }
      for (const key in items) {
        if (key === 'job') {
          continue
        }
        if (key === 'lclSlaves') {
          items[key] = sortByMultiFieldAndOrder(items[key], { jobNo: 'asc', dateCreated: 'desc' })
        }
        this._data[key] = items[key] || null
      }
    })
    this.syncCargoDoc()
    this.checkCargoDoc()
  }
  // 给cargoDoc和seaCargoDoc赋同一个对象
  syncCargoDoc() {
    if (this._data.cargoDoc) {
      this._data.seaCargoDoc = this._data.cargoDoc
    } else if (this._data.seaCargoDoc) {
      this._data.cargoDoc = this._data.seaCargoDoc
    }
  }
  checkCargoDoc() {
    if (!this.seaCargoDoc) {
      return
    }
    /* 有重复的MBL、HBL，只保留uuid最小的记录(和cargo默认取值保持一致)，其他的移除 */
    const list = this.seaCargoDoc
    let mbl = null
    let hbl = null
    const deletedCargoDocs = []
    for (let i = list.length - 1; i >= 0; --i) {
      if (list[i].docType === CargoDocConsts.MBL) {
        if (!mbl || list[i].uuid < mbl.uuid) {
          mbl = list[i]
        }
        deletedCargoDocs.push(list[i])
        list.splice(i, 1)
      } else if (list[i].docType === CargoDocConsts.HBL) {
        if (!hbl || list[i].uuid < hbl.uuid) {
          hbl = list[i]
        }
        deletedCargoDocs.push(list[i])
        list.splice(i, 1)
      }
    }
    if (mbl) {
      list.push(mbl)
    }
    if (hbl) {
      list.push(hbl)
    }
    this._data.deletedCargoDocs = deletedCargoDocs.filter(p => {
      if (mbl && p.uuid === mbl.uuid) {
        return false
      }
      if (hbl && p.uuid === hbl.uuid) {
        return false
      }
      return true
    })
  }
  async getCargoDoc() {
    const data = this._data
    if (typeof data.cargoDoc !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'cargoDoc': true })
      } else {
        if (data.seaCargoDoc) {
          data.cargoDoc = data.seaCargoDoc
        } else {
          data.cargoDoc = data.seaCargoDoc = []
        }
      }
    }
    return data.cargoDoc
  }
  async getSeaCargoDoc() {
    const data = this._data
    if (typeof data.seaCargoDoc !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'seaCargoDoc': true })
      } else {
        if (data.cargoDoc) {
          data.seaCargoDoc = data.cargoDoc
        } else {
          data.seaCargoDoc = data.cargoDoc = []
        }
      }
    }
    return data.seaCargoDoc
  }
  async removeAmsBlankCargoDoc() {
    const data = this._data
    for (let i = data.seaCargoDoc.length - 1; i >= 0; i--) {
      const item = data.seaCargoDoc[i]
      if ((!item.uuid) && ['AMS', 'AFR'].includes(item.docType)) {
        data.seaCargoDoc.splice(i, 1)
      }
    }
  }
  async getMainMbl() {
    const seaCargoDoc = await this.getSeaCargoDoc()
    for (const item of seaCargoDoc) {
      if (item.docType === CargoDocConsts.MBL) {
        return item
      }
    }
    return null
  }
  async getMainHbl() {
    const seaCargoDoc = await this.getSeaCargoDoc()
    for (const item of seaCargoDoc) {
      if (item.docType === CargoDocConsts.HBL) {
        return item
      }
    }
    return null
  }
  async getMscCargoDoc() {
    const data = this._data
    if (typeof data.mscCargoDoc !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'mscCargoDoc': true })
      } else {
        data.mscCargoDoc = []
      }
    }
    return data.mscCargoDoc
  }
  async getVgms() {
    const data = this._data
    if (typeof data.vgms !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'vgms': true })
      } else {
        data.vgms = []
      }
    }
    return data.vgms
  }
  async getCargoBulkDetail() {
    const data = this._data
    if (typeof data.cargoBulkDetail !== 'object') {
      if (data.uuid) {
        await this.loadJobRelated({ 'cargoBulkDetail': true })
      } else {
        data.cargoBulkDetail = []
      }
    }
    return data.cargoBulkDetail
  }
  async getLclMaster() {
    const data = this._data
    if (typeof data.lclMaster !== 'object') {
      if (data.lclMasterUuid) {
        data.lclMaster = await getSeaExportJobByUuid(data.lclMasterUuid).then(res => res.data ? res.data : null)
      } else {
        data.lclMaster = null
      }
    }
    return data.lclMaster
  }
  async getEdiFeedBackStates() {
    const data = this._data
    if (data.uuid) {
      data.ediFeedBackStates = await queryEDIFeedBackState({ jobUuid: data.uuid }).then(res => res.data)
    } else {
      data.ediFeedBackStates = []
    }
    return data.ediFeedBackStates
  }
  // 批量复制小票，组装数据返回给前台
  async batchCloneLcLJob() {
    return await batchCloneLcLJob({ jobUuid: this._data.uuid, branchId: $store.getters.currentOfficeId }).then(res => res.data)
  }

  /**
   * 用于获取拆并单提单装箱信息
   * @param docType
   * @returns {Promise<*[]>}
   */
  async getDocByDocType(docType) {
    const seaCargoDocs = await this.getSeaCargoDoc()
    const result = []
    for (const item of seaCargoDocs) {
      if (item.docType === docType) {
        if (!item.ediContainer || item.ediContainer.length <= 0) {
          await new SeaCargoDoc(item).loadCargoDocRelated(false, true, false)
        }
        result.push(item)
      }
    }
    return result
  }
}
